import { Grouping } from "../types";

// Utility function to convert cents to dollars
export const centsToDollars = (cents: number): number => {
  if (cents < 0) {
    return -Math.abs(cents) / 100;
  }
  return cents / 100;
};

// Helper function to format tradeTime in seconds to a readable format
export const formatTradeTime = (seconds: number): string => {
  if (seconds < 60) {
    return `${seconds} second${seconds === 1 ? "" : "s"}`;
  } else {
    const minutes = Math.floor(seconds / 60);
    return `${minutes} minute${minutes === 1 ? "" : "s"}`;
  }
};

// Helper to build a tree from flat data for row spanning
export function buildGroupTree<T extends { groupKey: string }>(
  data: T[],
  groupings: Grouping[]
) {
  function groupByLevel<T extends { groupKey: string }>(
    items: T[],
    level: number
  ): any[] {
    if (level >= groupings.length) return items;
    const groupMap = new Map<string, T[]>();
    items.forEach((item) => {
      const key = item.groupKey.split(" + ")[level] || "";
      const currentItems = groupMap.get(key) || [];
      currentItems.push(item);
      groupMap.set(key, currentItems);
    });
    return Array.from(groupMap.entries()).map(([key, children]) => ({
      key,
      children: groupByLevel(children, level + 1),
      isLeaf: level === groupings.length - 1,
      // For leaf nodes, children is an array of AggregatedTradeData
    }));
  }
  return groupByLevel<T>(data, 0);
}

export function capitaliseFirstLetter(val: string) {
  return String(val).charAt(0).toUpperCase() + String(val).slice(1);
}
